import { render, staticRenderFns } from "./TabColor.vue?vue&type=template&id=5c796392&scoped=true&"
import script from "./TabColor.vue?vue&type=script&lang=js&"
export * from "./TabColor.vue?vue&type=script&lang=js&"
import style0 from "./TabColor.vue?vue&type=style&index=0&id=5c796392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c796392",
  null
  
)

export default component.exports